/**
 * Developer flags for testing and debugging.
 * DEV_FLAGS are only active in development mode.
 *
 * Toggle FORCE_SKELETON to keep all DataSection skeletons visible.
 * Set SKELETON_DELAY_MS to add artificial delay before content reveals.
 *
 * RELEASE_FLAGS are active in all environments (dev + production).
 * Use these to gradually roll out features before making them permanent.
 */
export const DEFAULT_DEV_SUBSCRIPTION_TIER = 'research';

const DEV_FLAGS = {
  FORCE_SKELETON: false,
  SKELETON_DELAY_MS: 0,
  SUBSCRIPTION_TIER: DEFAULT_DEV_SUBSCRIPTION_TIER,
  TECH_STACK: true,
  ACQUISITIONS_FULL: true,
  AI_TRACKING: true,
  FEDERAL_DEALS: true,
  SERVICE_HEALTH: true,
  ADOPTION_ARTIFACT_CATALOG: true,
  // Products as first-class entities: product search, /product pages, product tags and
  // the company Products list. Off until the product UI is redesigned; set true to preview.
  PRODUCTS: false,
};

const RELEASE_FLAGS = {
  MCP: true,
  EXCHANGE_VOLUME: false,
  SI_HIRING: true,
  GUIDANCE_PREVIEW: true,
  FILING_INTELLIGENCE_PREVIEW: false,
  JOB_POSTINGS_DAILY: true,
  DEVELOPER_SIGNALS_DAILY: true,
  ADOPTION_SIGNALS_V2: true,
  DEVELOPER_SIGNALS_LEADERBOARD: false,
};

export const getDevFlag = (flag) => {
  if (flag in RELEASE_FLAGS) return RELEASE_FLAGS[flag];
  if (process.env.NODE_ENV !== 'development') return false;
  if (flag === 'SKELETON_DELAY_MS') {
    const envDelay = Number(process.env.REACT_APP_SKELETON_DELAY_MS);
    if (Number.isFinite(envDelay) && envDelay > 0) return envDelay;
  }
  return DEV_FLAGS[flag] ?? false;
};
